import React, { useState, useEffect, useContext, forwardRef } from "react";

import { OccupantTypeContext } from "context/CommonProvider";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

const SelectOccupantType = forwardRef((props, ref) => {
  const [occupantType, setOccupantType] = useState(null);
  const [errorOccupantType, setErrorOccupantType] = useState(null);

  const handleChange = (event, newValue) => {
    setOccupantType(newValue);

    props.parentCallback(newValue);
  };

  useEffect(() => {
    setOccupantType(props.dataParentToChild);
    setErrorOccupantType(props.errorParentToChild);
  }, [props.dataParentToChild, props.errorParentToChild]);

  const occupantTypeContext = useContext(OccupantTypeContext);
  const items = [];
  for (var [key, value] of Object.entries(occupantTypeContext)) {
    items.push({ label: value, id: key });
  }

  return (
    <>
      <Autocomplete
        disableClearable
        value={occupantType}
        onChange={handleChange}
        disablePortal
        id="occupantType"
        options={items}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) =>
          value === undefined ||
          value === "" ||
          option.id === value.id ||
          option.nome === value.nome
        }
        noOptionsText={"Nenhum cadastrado"}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="dense"
            inputRef={ref}
            error={errorOccupantType}
            label="Tipo de Ocupante"
          />
        )}
      />
    </>
  );
});

export default SelectOccupantType;
